import { getPropertyTypeSet } from '@aloft/toolkit-shared';

import { Tkv2OrderContext } from '../../../../controller/types.js';
import { PairedCostAdjustmentSummaryProps } from '../types.js';
import { makeAdjustmentLabelDictionary } from './makeAdjustmentLabelDictionary.js';
import { makeExceptionsDictionary } from './makeExceptionsDictionary.js';
import { makeRollupDictionary } from './makeRollupDictionary.js';
import { makeSimpleValueAndAdjustmentDictionary } from './makeSimpleValueAndAdjustmentDictionary.js';

export const pairedCostAdjustmentSummaryPropsFromOrderContext = (
  context: Tkv2OrderContext,
): PairedCostAdjustmentSummaryProps => {
  return {
    compSequence: context.compSequence,

    indicatedValue: context.pairedCostResults.subject?.totals?.costApproach?.indicatedValue,
    subject: {
      ...makeSimpleValueAndAdjustmentDictionary(context, 'subject'),
      ...makeExceptionsDictionary(context, 'subject'),
    },
    comps: Object.fromEntries(
      context.compSequence.map((compID) => [
        compID,
        {
          ...makeSimpleValueAndAdjustmentDictionary(context, compID),
          ...makeExceptionsDictionary(context, compID),
          ...makeRollupDictionary(context, compID),
        },
      ]),
    ),
    adjustmentLabels: makeAdjustmentLabelDictionary(context),
    pairedCostSettings: context.pairedCostSettings,
    savePairedCostSettings: context.savePairedCostSettings,
    propertyTypeSet: getPropertyTypeSet(context.subject.body, context.comps, context.compSequence),
    isSimplifiedMode: context.pairedCostVersion === 'simplified_v1',
    pairedCostVersion: context.pairedCostVersion,
  };
};
